import React, { useState, useEffect } from "react"

import './PushMessagesAdd.scss'

import Axios from 'axios';

import { connect } from 'react-redux'

import { useSelector } from 'react-redux'

import { ArrowLeft } from "react-feather";

import { useHistory, useParams } from "react-router-dom";

import PageHeading from "../../components/commonComponents/pageHeading/pageHeading";

import BadgeSelect from "./BadgeSelect/BadgeSelect";

import { setAlert } from "../../redux/actions/alertActions";

import { hostDetect } from "../../config/envConfig";


const PushMessagesAdd = ({ setAlert }) => {

    const { id } = useParams()

    const site_id = useSelector(state => state.siteInfo.site.id)

    const [saveLoading, setSaveLoading] = useState(false);

    const [submitDisable, setSubmitDisable] = useState(true);

	const [pushLinkValidation, setPushLinkValidation] = useState({valid: false, class: '', text: ''});
 	const [pushLink, setPushLink] = useState('');

    const [pushTitleValidation, setPushTitleValidation] = useState({valid: false, class: '', text: ''});
 	const [pushTitle, setPushTitle] = useState('');

    const [pushDescriptionValidation, setPushDescriptionValidation] = useState({valid: false, class: '', text: ''});
 	const [pushDescription, setPushDescription] = useState('');

    const [image, setImage] = useState(null);
    const [imageName, setImageName] = useState('Выберите изображение');
    const [imageError, setImageError] = useState('')

    const [icon, setIcon] = useState(null);
    const [iconName, setIconName] = useState('Выберите иконку');
    const [iconError, setIconError] = useState('')

    const [badge, setBadge] = useState({name: '', file: ''})
    const [badgeSize, setBadgeSize] = useState('')

    const [postTimeRadio, setPostTimeRadio] = useState('immediately')
    const [postTime, setPostTime] = useState(null)

    useEffect(()=>{
        if(pushLinkValidation.valid &&
            pushTitleValidation.valid &&
            pushDescriptionValidation.valid &&
            image &&
            icon &&
            badge.file.length > 0 &&
            (postTimeRadio === 'immediately' || (postTimeRadio === 'custom' && postTime?.length))
        ){
            setSubmitDisable(false)
        } else {
            setSubmitDisable(true)
        }
    });

    // get data if edit with id
    useEffect(() => {

        if(id){
            setSaveLoading(true)

            Axios.get(`${hostDetect('api')}/push-ad/get?id=${id}`, {withCredentials: true})
                .then(response => {
                    const success = response.data.success;

                    setSaveLoading(false)

                    if(success){
                        const { url, title, body, image, icon, badge } = response.data.data.entry

                        setPushLink(url)
                        handlePushLinkInput(url)

                        setPushTitle(title)
                        handlePushTitleInput(title)

                        setPushDescription(body)
                        handlePushDescriptionInput(body)

                        setImage(image)

                        setIcon(icon)

                        setBadge({name: '', file: badge})

                    } else {
                        let errMessage = response.data.data.message;
                        setAlert('error', errMessage);
                    }
                })
                .catch(err => {
                    setSaveLoading(false)
                    setAlert('error', 'Не получилось отправить запрос!');
                })
        }

    }, [id])


    let history = useHistory();

	const handleBackClick = () => {
		history.goBack()
	}

    // url validation
    const handlePushLinkInput = link => {
		let linkRegex = /(http(s?)):\/\//i;

		setPushLink(link)

		if(link.length === 0){
 			setPushLinkValidation({valid: false, class: '', text: ''})
 		} else if(link.length > 0 && !linkRegex.test(link)){
 			setPushLinkValidation({valid: false, class:'is-invalid', text: 'Неверный формат записи...'})
 		} else if(link.length > 0 && linkRegex.test(link)){
 			setPushLinkValidation({valid: true, class: 'is-valid', text: ''})
 		}
	}

    // title validation
    const handlePushTitleInput = title => {

		setPushTitle(title);

		if(title.length === 0){
 			setPushTitleValidation({valid: false, class: '', text: ''})
 		} else if(title.length <= 4){
 			setPushTitleValidation({valid: false, class:'is-invalid', text: 'Слишком короткий заголовок...'})
 		} else if(title.length > 4){
 			setPushTitleValidation({valid: true, class: 'is-valid', text: ''})
 		}
	}

    // description validation
    const handlePushDescriptionInput = description => {

		setPushDescription(description);

		if(description.length === 0){
 			setPushDescriptionValidation({valid: false, class: '', text: ''})
 		} else if(description.length <= 4){
 			setPushDescriptionValidation({valid: false, class:'is-invalid', text: 'Слишком короткое описание...'})
 		} else if(description.length > 4){
 			setPushDescriptionValidation({valid: true, class: 'is-valid', text: ''})
 		}
	}

    // image validation
    const handleFileInput = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check if this is an image
        if (!file.type.match('image.*')) {
            setImageError('Пожалуйста, выберите изображение (JPEG, PNG и т.д.)');
            return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const { width, height } = img;

                if (width <= 360 && height <= 240) {
                    setImage(event.target.result); // save as base64
                    setImageError('');
                    setImageName(file.name)
                } else {
                    setImageError(`Изображение слишком большое. Максимум: 360×240. Ваше: ${width}×${height}`);
                    setImage(null);
                    setImageName('Выберите изображение')
                }
            };

            img.onerror = () => {
                setImageError('Не удалось загрузить изображение');
                setImage(null);
                setImageName('Выберите изображение')
            };
        };

        reader.readAsDataURL(file);
    }

    // icon validation
    const handleIconFileInput = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // Check if this is an image
        if (!file.type.match('image.*')) {
            setIconError('Пожалуйста, выберите изображение (JPEG, PNG и т.д.)');
            return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();
            img.src = event.target.result;

            img.onload = () => {
                const { width, height } = img;

                if (width <= 192 && height <= 192) {
                    setIcon(event.target.result); // save as base64
                    setIconError('');
                    setIconName(file.name)
                } else {
                    setIcon(null);
                    setIconError(`Изображение слишком большое. Максимум: 192×192. Ваше: ${width}×${height}`);
                    setIconName('Выберите изображение')
                }
            };

            img.onerror = () => {
                setIcon(null);
                setIconError('Не удалось загрузить изображение');
                setIconName('Выберите изображение')
            };
        };

        reader.readAsDataURL(file);
    }


    // time
    const handlePostTimeRadio = (radioValue) => {
        setPostTimeRadio(radioValue)
        setPostTime(null)
    }

    // create
    const handleSubmit = () => {

        setSaveLoading(true)

        let formData = new FormData();
        formData.append('image', image);
        formData.append('icon', icon);
        formData.append('badge', badge.file);
        formData.append('title', pushTitle);
        formData.append('body', pushDescription)
        formData.append('url', pushLink);
        if(postTime){
            formData.append('published', postTime);
        }

        Axios.post(`${hostDetect('api')}/push-publisher-ad/create?site_id=${site_id}`, formData, {withCredentials: true})
            .then(response => {

                // setSaveLoading(false)

                let success = response.data.success;

                if(success){
                    setAlert('success', 'Уведомление создано! Переходим на список уведомлений...')

                    setTimeout(() => {
                        history.push('/push-sending')
                    }, 3000)
                } else {
                    let errMessage = response.data.data.message;

                    setSaveLoading(false)
                    setAlert('error', errMessage)
                }
            })
            .catch(err => {
                setSaveLoading(false)
                setAlert('error', 'Не удалось отправить запрос! Обновите страницу и попробуйте снова')
            })
    }

    // update
    const handleUpdate = () => {

        if(id){
            setSaveLoading(true)

            let formData = new FormData();

            if(image.indexOf('data:image/png;base64') !== -1 || image.indexOf('data:image/jpeg;base64') !== -1){
                formData.append('image', image);
            }

            if(icon.indexOf('data:image/png;base64') !== -1 || icon.indexOf('data:image/jpeg;base64') !== -1){
                formData.append('icon', icon);
            }

            if(badge.file.indexOf('data:image/png;base64') !== -1 || badge.file.indexOf('data:image/jpeg;base64') !== -1){
                formData.append('badge', badge.file);
            }

            formData.append('title', pushTitle);
            formData.append('body', pushDescription)
            formData.append('url', pushLink);
            if(postTime){
                formData.append('published', postTime);
            }


            Axios.post(`${hostDetect('api')}/push-ad/update?id=${id}`, formData, {withCredentials: true})
                .then(response => {

                    setSaveLoading(false)

                    let success = response.data.success;

                    if(success){
                        setAlert('success', 'Уведомление обновлено!')
                    } else {
                        let errMessage = response.data.data.message;
                        setAlert('error', errMessage)
                    }
                })
                .catch(err => {
                    setSaveLoading(false)
                    setAlert('error', 'Не удалось отправить запрос! Обновите страницу и попробуйте снова')
                })
        }

    }
    
    return (
        <div className="push-messages-add">

            <div className="add-internal-promotion__back-btn">
                <button className="btn w-sm mb-1 btn-secondary" onClick={handleBackClick}>
                    <ArrowLeft size={15} style={{marginRight: 10}}/>Назад
                </button>
            </div>

            <PageHeading 
                mainText={`${id ? 'Редактирование' : 'Добавление'} Push-уведомления`} 
                mutedText={`Заполните поля и ${id ? 'отредактируйте' : 'добавьте новое'} push-уведомление`}/>

            <div className="row">
                <div className="col-md-6">
                    <div className="card mb-5">
                        <div className="card-header">
                            Добавить push-уведомление
                        </div>
                        <div className="card-body">

                            {/* url */}
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Ссылка (URL)</label>
                                <div className="col-sm-8">
                                    <input 
                                        type="text" 
                                        className={"form-control " + pushLinkValidation.class} 
                                        placeholder="http://" 
                                        value={pushLink} 
                                        onChange={(e) => handlePushLinkInput(e.target.value)} />
                                    {
                                        pushLinkValidation.valid === false ? 
                                            <ul className="list-unstyled text-sm mt-1 text-muted filled add-internal-promotion__input-error-text">
                                                <li className="parsley-required text-danger">{pushLinkValidation.text}</li>
                                            </ul> : ''
                                    }
                                </div>
                            </div>

                            {/* title */}
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Заголовок</label>
                                <div className="col-sm-8" style={{paddingBottom: 20}}>
                                    <input 
                                        type="text" 
                                        className={"form-control " + pushTitleValidation.class} 
                                        placeholder="Добавьте заголовок" 
                                        value={pushTitle} 
                                        onChange={(e) => handlePushTitleInput(e.target.value)}
                                        maxLength={26} 
                                        spellCheck />
                                    <span className="md-input-msg" style={{right: 15}} >{pushTitle.length}/26</span>
                                    {
                                        pushTitleValidation.valid === false ? 
                                            <ul className="list-unstyled text-sm mt-0 mb-0 text-muted filled add-internal-promotion__input-error-text">
                                                <li className="parsley-required text-danger">{pushTitleValidation.text}</li>
                                            </ul> : ''
                                    }
                                </div>
                            </div>

                            {/* description */}
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Текст</label>
                                <div className="col-sm-8" style={{paddingBottom: 20}}>
                                    <textarea 
                                        rows="5"
                                        type="text" 
                                        className={"form-control " + pushDescriptionValidation.class} 
                                        value={pushDescription} 
                                        onChange={(e) => handlePushDescriptionInput(e.target.value)}
                                        maxLength={36}
                                        placeholder="Введите текст нового уведомления"
                                        spellCheck />
                                        <span className="md-input-msg" style={{right: 15}} >{pushDescription.length}/36</span>
                                        {
                                            pushDescriptionValidation.valid === false ? 
                                                <ul className="list-unstyled text-sm mt-0 mb-0 text-muted filled add-internal-promotion__input-error-text">
                                                    <li className="parsley-required text-danger">{pushDescriptionValidation.text}</li>
                                                </ul> : ''
                                        }
                                </div>
                            </div>

                            {/* image */}
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Изображение (360x240)</label>
                                <div className="col-sm-8">
                                    <div className="custom-file">
                                        <input 
                                            type="file" 
                                            className="custom-file-input" 
                                            id="customFile" 
                                            onChange={handleFileInput} 
                                            accept=".jpg, .jpeg, .png"/>
                                        <label className={"custom-file-label " + (image ? 'is-valid' : '')} htmlFor="customFile">
                                            {
                                                imageName
                                            }
                                        </label>

                                            {
                                                imageError.length ? 
                                                    <small style={{textAlign: 'end'}} className='form-text text-muted text-danger text-success'>
                                                        {imageError}
                                                    </small> : 
                                                    null
                                            }                                    
                                    </div>
                                </div>
                                {
                                    image ? (
                                        <div className="preview-block">
                                            <div className="image-preview">
                                                <img src={image} />
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>

                            {/* icon */}
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Иконка (192x192)</label>
                                <div className="col-sm-8">
                                    <div className="custom-file">
                                        <input 
                                            type="file" 
                                            className="custom-file-input" 
                                            id="customFile2" 
                                            onChange={handleIconFileInput} 
                                            accept=".jpg, .jpeg, .png"/>
                                        <label className={"custom-file-label " + (icon ? 'is-valid' : '')} htmlFor="customFile2">
                                            {
                                                iconName
                                            }
                                        </label>

                                            {
                                                iconError.length ? 
                                                    <small style={{textAlign: 'end'}} className='form-text text-muted text-danger text-success'>
                                                        {iconError}
                                                    </small> : 
                                                    null
                                            }                                    
                                    </div>
                                </div>
                                {
                                    icon ? (
                                        <div className="preview-block">
                                            <div className="icon-preview">
                                                <img src={icon} />
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>

                            {/* badge */}
                            <BadgeSelect badge={badge} setBadge={setBadge} badgeSize={badgeSize} setBadgeSize={setBadgeSize} />

                            {/* time post */}
                            <div className="form-group row">
                                <label className="col-sm-4 col-form-label">Опубликовать:</label>
                                <div className="col-sm-8">
                                    <div className="mt-2">
                                        <div className="form-check form-check-inline">
                                            <label htmlFor="immediately" className="form-check-label">
                                                <input 
                                                    id="immediately" 
                                                    type="radio" 
                                                    className="form-check-input" 
                                                    name="post-time" 
                                                    value="immediately" 
                                                    onChange={() => handlePostTimeRadio('immediately')} 
                                                    checked={postTimeRadio === 'immediately' ? true : false} />
                                                Немедленно
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <label htmlFor="custom" className="form-check-label">
                                                <input 
                                                    id="custom" 
                                                    type="radio" 
                                                    className="form-check-input" 
                                                    name="post-time" 
                                                    value="custom" 
                                                    onChange={() => setPostTimeRadio('custom')} 
                                                    checked={postTimeRadio === 'custom' ? true : false} />
                                                Указать время
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {
                                postTimeRadio === 'custom' ? (
                                    <div className="form-group row">
                                        <label className="col-sm-4 col-form-label">Дата:</label>
                                        <div className="col-sm-8">
                                            <input 
                                                type="datetime-local" 
                                                className="form-control" 
                                                name="post-date" 
                                                onChange={(e) => setPostTime(e.target.value)} 
                                                checked={postTime === 'immediately' ? true : false} />
                                        </div>
                                    </div>
                                    ) : null
                            }


                            {/* submit */}
                            <div className="push-messages-add__save-btn">
                                {
                                    id ? (
                                        <button
                                            className="btn w-sm mb-1 btn-success"
                                            disabled={submitDisable || saveLoading}
                                            onClick={handleUpdate}>Обновить</button>
                                    ) : (
                                        <button 
                                            className="btn w-sm mb-1 btn-success" 
                                            disabled={submitDisable || saveLoading} 
                                            onClick={handleSubmit}>Сохранить</button>
                                    )
                                }
 							</div>


                             {
                                saveLoading ? (
                                    <div className="alert alert-info">
                                    <div className="spinner-border spinner-border-sm text-primary mr-3" role="status">
                                        <span className="sr-only">Загрузка...</span>
                                    </div>
                                    Сохранение...
                                    </div>
                                ) : null
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


const mapDispatchToProps = {
    setAlert
  }
  
export default connect(null, mapDispatchToProps)(PushMessagesAdd)